import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

export const translations = {
  zh: {
    brand: "你好功德",
    brandSub: "CiAO Merit",
    tagline: "连接善心，敬祖感恩，共享福报",
    nav: {
      home: "首页",
      about: "简介",
      daily: "每日功德",
      projects: "功德项目",
      charity: "慈善爱心",
      lotus: "莲花祈福",
      deity: "神明护佑",
      member: "会员系统",
      dashboard: "个人命盘",
      profile: "个人页面",
      admin: "管理后台",
      numerology: "易经数字",
    },
    common: {
      signup: "报名参与",
      share: "分享",
      login: "登入",
      logout: "登出",
      register: "注册",
      loginRegister: "登入 / 注册",
      account: "我的账户",
      viewMore: "了解更多",
      price: "价格",
      free: "免费",
      points: "功德点数",
      pointsUnit: "点",
      earnPoints: "可获得",
      loading: "加载中…",
      submit: "提交",
      cancel: "取消",
      confirm: "确认",
      save: "保存",
      copy: "复制",
      copied: "已复制",
      close: "关闭",
      required: "必填",
      whatsapp: "WhatsApp 联系",
      joinGroup: "加入 WhatsApp 群",
      quantity: "数量",
      total: "合计",
      recommended: "推荐",
      viewAll: "查看全部",
      backHome: "返回首页",
      search: "搜索",
      navigate: "导航",
      status: "状态",
      amount: "金额",
    },
    master: {
      open: "每日师傅",
      title: "每日师傅 · CiAO Master",
      subtitle: "每日命理问答 · 风趣解惑",
      greeting: "你好呀～我是命盘师傅 CiAO Master。今天想问运势、生肖、风水，还是开运小撇步？尽管问！（仅供娱乐参考哦）",
      placeholder: "问问师傅今天的运势…",
      thinking: "师傅掐指一算中…",
      error: "师傅走神了，请再问一次～",
    },
    welcome: {
      cta: "开始积功德",
      ctaSub: "登入会员，查看专属每日运程",
      feature1Title: "每日运程",
      feature1Desc: "依据您的八字，AI 为您解读今日运势、能量与开运指引。",
      feature2Title: "功德项目",
      feature2Desc: "供灯、放生、印经、慈善…每一份善心都化作温暖。",
      feature3Title: "莲花祈福",
      feature3Desc: "折莲修心，点亮莲花，为至亲祈福纳祥。",
      valuesTitle: "一份爱心 · 一份温暖",
    },
    auth: {
      loginTitle: "会员登入",
      registerTitle: "注册新会员",
      name: "姓名",
      email: "电子邮箱",
      password: "密码",
      phone: "联系电话",
      refCode: "推荐码（选填）",
      noAccount: "还没有账户？",
      hasAccount: "已有账户？",
      toRegister: "立即注册",
      toLogin: "前往登入",
      welcomeBack: "欢迎回来",
      loginSuccess: "登入成功",
      registerSuccess: "注册成功，欢迎加入！",
    },
    profileForm: {
      title: "完善个人资料",
      reminder: "温馨提醒：请完整填写个人资料（电话、阳历出生年月日时），即可解锁您的每日运程 🙏",
      gender: "性别",
      male: "男",
      female: "女",
      birthDate: "阳历出生日期",
      birthTime: "出生时辰",
      year: "年",
      month: "月",
      day: "日",
      hour: "时",
      minute: "分",
      saved: "资料已保存",
      completeness: "资料完整度",
    },
    dashboard: {
      greeting: "愿今日吉祥安康",
      todayFortune: "今日运程",
      score: "综合运势",
      overall: "运势概述",
      bazi: "八字运势",
      energy: "今日能量",
      colors: "适合的颜色",
      directions: "方向优势",
      numbers: "合适数字",
      benefactor: "贵人生肖",
      cautions: "该注意的",
      avoid: "不适合",
      tip: "开运小建议",
      recommend: "今日推荐功德",
      wallet: "功德点数",
      myBazi: "我的八字",
      pillars: "四柱",
      today: "今日",
      tabDaily: "每日运程",
      tabWeekly: "每周运程",
      tabChart: "命盘详批",
      tabTaisui: "犯太岁",
    },
    weekly: {
      title: "本周运程",
    },
    chart: {
      title: "命盘总览",
      year: "年柱", month: "月柱", day: "日柱", time: "时柱",
      lunar: "农历", solar: "阳历",
      mingGong: "命宫", shenGong: "身宫", taiYuan: "胎元",
      pillarsTitle: "八字排盘明细",
      viewGanzhi: "干支", viewShiShen: "十神·六亲", viewPalace: "宫位", viewFlow: "流通",
      hideGan: "藏干", naYin: "纳音", diShi: "地势", xunKong: "旬空",
      ganShiShen: "天干十神", zhiShiShen: "地支十神",
      wuxingDist: "五行分布",
      xiuTitle: "二十八星宿", zheng: "七政", animal: "宿禽", gong: "方位宫",
      sixiangTitle: "四象方位",
      dayQi: "日柱气象", reading: "命局解读",
      personality: "性格", career: "事业", wealth: "财运", relationship: "感情人际", health: "健康", advice: "开运建议",
      dayunTitle: "大运 · 流年", startYun: "起运", current: "当前", liunian: "近年流年",
      exportPdf: "下载命盘 PDF",
      fengshuiTitle: "个人风水开运方向",
      fengshuiDesc: "依据你的喜用五行，为你梳理开运方位、颜色、物件与布局建议",
      fsFavorable: "开运吉方", fsAvoid: "宜减弱方位", fsColors: "开运颜色", fsItems: "开运物件 · 材质",
      fsBedDesk: "睡床 · 办公桌朝向", fsHome: "家居 · 办公布局", fsWear: "开运穿戴建议",
      deepTitle: "命盘详解", deepDesc: "点击展开各面向的深入解读",
      talents: "天赋优势", marriage: "婚姻姻缘", relatives: "六亲人际", wealthTypes: "正财 · 偏财",
      disclaimer: "命理解读仅供参考，命运掌握在自己手中。",
    },
    card: {
      title: "命局名卡", zodiac: "生肖", dayMaster: "日主",
      download: "下载名卡", share: "分享",
      downloaded: "名卡已下载", exportError: "生成失败，请重试",
      shareText: "我的命局总述 · 你好功德 CiAO Merit",
      shareHint: "名卡图片已下载，可在 WhatsApp 中附上分享",
      placeholder: "命局总述生成中…",
    },
    bankin: {
      title: "报名 · 银行汇款",
      step1: "确认项目",
      step2: "银行汇款",
      step3: "上传收据",
      step4: "等待确认",
      usePoints: "使用功德点数抵扣",
      pointsAvail: "可用点数",
      cashToPay: "需汇款",
      participant: "报名人资料",
      bankInfo: "请汇款至以下账户",
      bankName: "银行",
      accountName: "户名",
      accountNo: "账号",
      uploadReceipt: "上传汇款收据",
      bankRef: "汇款参考号（选填）",
      pendingTitle: "报名成功，等待确认",
      pendingDesc: "我们已收到您的报名与收据，管理员确认后功德点数将自动入账，您可在个人页面查看进度。",
      createOrder: "确认并前往汇款",
      submitReceipt: "提交收据",
      profileNeeded: "报名前请先登入会员",
    },
    orderStatus: {
      pending: "待确认",
      approved: "已确认",
      rejected: "已拒绝",
    },
    profile: {
      title: "个人后台",
      info: "个人资料",
      myProjects: "我参与的项目",
      referral: "推荐好友",
      myPoints: "我的功德点数",
      referralDesc: "分享您的专属推荐链接，好友注册即可获得 0.1 点奖励，好友消费再享 5% 回馈点数！",
      referralCode: "我的推荐码",
      referralLink: "推荐链接",
      whoJoined: "通过我加入的好友",
      noReferral: "还没有好友通过您的链接加入，快去分享吧！",
      noOrders: "您还没有参与任何项目",
      ledger: "点数明细",
      totalReward: "推荐累计奖励",
      uploadReceipt: "补上传付款证明", reupload: "重新上传", viewReceipt: "查看收据",
      awaitingReceipt: "待上传付款证明",
      uploadReceiptDesc: "请上传您的银行汇款收据截图，管理员确认后将为您入账功德点数。",
      receiptImage: "付款证明图片", bankRef: "汇款参考（可选）", receiptUploaded: "付款证明已上传，待管理员确认",
    },
    lotus: {
      meaning: "折莲花的意义",
      class: "莲花折叠班",
      paper: "莲花纸购买",
      videos: "莲花教学视频",
      light: "点亮莲花功德",
      blessing: "初一莲花祈福",
    },
    deity: {
      intro: "神明简介",
      map: "神明地图",
      searchPlaceholder: "搜索神明，例如：观音",
      mapNeedKey: "地图功能需要配置 Google Maps API Key（可在管理后台设置）。以下为神明地址，可点击导航。",
      address: "地址",
    },
    admin: {
      title: "管理后台",
      overview: "数据概览",
      orders: "订单 / 汇款确认",
      projects: "项目管理",
      members: "会员管理",
      deities: "神明管理",
      settings: "网站设置",
      members_count: "会员总数",
      pending: "待确认订单",
      revenue: "已确认收入 (RM)",
      pointsIssued: "已发放点数",
      approve: "确认",
      reject: "拒绝",
      viewReceipt: "查看收据",
      export: "导出 Excel",
      addProject: "新增项目",
      editProject: "编辑项目",
      addDeity: "新增神明",
      revenueByCat: "分类收入",
      dailyRevenue: "每日收入趋势",
      noReceipt: "未上传收据",
    },
    footer: {
      about: "你好功德 CiAO Merit 是一个连接善心、共享福报的功德平台。",
      contact: "联系我们",
      quickLinks: "快速链接",
      rights: "版权所有",
    },
    categories: {
      daily_merit: "每日功德",
      merit_project: "功德项目",
      charity: "慈善爱心",
      lotus: "莲花祈福",
    },
  },
  en: {
    brand: "CiAO Merit",
    brandSub: "你好功德",
    tagline: "Connect kindness, honor ancestors, share blessings",
    nav: {
      home: "Home",
      about: "About",
      daily: "Daily Merit",
      projects: "Merit Projects",
      charity: "Charity",
      lotus: "Lotus Blessing",
      deity: "Deities",
      member: "Members",
      dashboard: "My Chart",
      profile: "Profile",
      admin: "Admin",
      numerology: "Yijing Numbers",
    },
    common: {
      signup: "Sign Up",
      share: "Share",
      login: "Login",
      logout: "Logout",
      register: "Register",
      loginRegister: "Login / Register",
      account: "My Account",
      viewMore: "Learn more",
      price: "Price",
      free: "Free",
      points: "Merit Points",
      pointsUnit: "pts",
      earnPoints: "Earn",
      loading: "Loading…",
      submit: "Submit",
      cancel: "Cancel",
      confirm: "Confirm",
      save: "Save",
      copy: "Copy",
      copied: "Copied",
      close: "Close",
      required: "required",
      whatsapp: "WhatsApp Us",
      joinGroup: "Join WhatsApp Group",
      quantity: "Qty",
      total: "Total",
      recommended: "Featured",
      viewAll: "View all",
      backHome: "Back home",
      search: "Search",
      navigate: "Navigate",
      status: "Status",
      amount: "Amount",
    },
    master: {
      open: "Daily Master",
      title: "Daily Master · CiAO Master",
      subtitle: "Your daily fortune companion",
      greeting: "Hi there! I'm CiAO Master. Ask me about today's luck, your zodiac, feng shui or a quick luck tip — go ahead! (Just for fun.)",
      placeholder: "Ask the Master about today…",
      thinking: "The Master is consulting the stars…",
      error: "The Master got distracted, please ask again~",
    },
    welcome: {
      cta: "Start Your Merit",
      ctaSub: "Log in to view your personalized daily fortune",
      feature1Title: "Daily Fortune",
      feature1Desc: "Based on your BaZi, AI reveals today's fortune, energy and lucky guidance.",
      feature2Title: "Merit Projects",
      feature2Desc: "Lamp offerings, life release, sutra printing, charity — kindness becomes warmth.",
      feature3Title: "Lotus Blessing",
      feature3Desc: "Fold lotus to calm the heart, light a lotus to bless your loved ones.",
      valuesTitle: "A bit of love · A bit of warmth",
    },
    auth: {
      loginTitle: "Member Login",
      registerTitle: "Create Account",
      name: "Name",
      email: "Email",
      password: "Password",
      phone: "Phone",
      refCode: "Referral code (optional)",
      noAccount: "No account yet?",
      hasAccount: "Already a member?",
      toRegister: "Register now",
      toLogin: "Go to login",
      welcomeBack: "Welcome back",
      loginSuccess: "Logged in successfully",
      registerSuccess: "Registered. Welcome aboard!",
    },
    profileForm: {
      title: "Complete Your Profile",
      reminder: "Gentle reminder: complete your profile (phone & full solar birth date/time) to unlock your daily fortune 🙏",
      gender: "Gender",
      male: "Male",
      female: "Female",
      birthDate: "Solar Birth Date",
      birthTime: "Birth Time",
      year: "Year",
      month: "Month",
      day: "Day",
      hour: "Hour",
      minute: "Min",
      saved: "Profile saved",
      completeness: "Profile completeness",
    },
    dashboard: {
      greeting: "Wishing you an auspicious day",
      todayFortune: "Today's Fortune",
      score: "Overall Score",
      overall: "Summary",
      bazi: "BaZi Fortune",
      energy: "Today's Energy",
      colors: "Lucky Colors",
      directions: "Lucky Directions",
      numbers: "Lucky Numbers",
      benefactor: "Benefactor Zodiac",
      cautions: "Cautions",
      avoid: "Avoid",
      tip: "Lucky Tip",
      recommend: "Recommended Today",
      wallet: "Merit Points",
      myBazi: "My BaZi",
      pillars: "Four Pillars",
      today: "Today",
      tabDaily: "Daily",
      tabWeekly: "Weekly",
      tabChart: "BaZi Chart",
      tabTaisui: "Tai Sui",
    },
    weekly: {
      title: "This Week",
    },
    chart: {
      title: "Chart Overview",
      year: "Year", month: "Month", day: "Day", time: "Hour",
      lunar: "Lunar", solar: "Solar",
      mingGong: "Life Palace", shenGong: "Body Palace", taiYuan: "Fetal Origin",
      pillarsTitle: "Four Pillars Detail",
      viewGanzhi: "Stems & Branches", viewShiShen: "Ten Gods · Relatives", viewPalace: "Palaces", viewFlow: "Flow",
      hideGan: "Hidden", naYin: "NaYin", diShi: "Stage", xunKong: "Void",
      ganShiShen: "Stem God", zhiShiShen: "Branch Gods",
      wuxingDist: "Five-Element Distribution",
      xiuTitle: "28 Mansions", zheng: "Planet", animal: "Animal", gong: "Direction",
      sixiangTitle: "Four Symbols",
      dayQi: "Day Pillar Climate", reading: "Chart Reading",
      personality: "Personality", career: "Career", wealth: "Wealth", relationship: "Relationships", health: "Health", advice: "Luck Tips",
      dayunTitle: "Luck Cycles · Years", startYun: "Start", current: "Now", liunian: "Upcoming Years",
      exportPdf: "Download PDF",
      fengshuiTitle: "Personal Feng Shui Directions",
      fengshuiDesc: "Based on your favourable elements — directions, colours, items & layout to boost your luck",
      fsFavorable: "Auspicious directions", fsAvoid: "Directions to ease", fsColors: "Lucky colours", fsItems: "Lucky items · materials",
      fsBedDesk: "Bed · desk facing", fsHome: "Home · office layout", fsWear: "What to wear",
      deepTitle: "In-depth Reading", deepDesc: "Tap to expand each aspect",
      talents: "Talents & Strengths", marriage: "Marriage", relatives: "Family & Bonds", wealthTypes: "Regular · Windfall Wealth",
      disclaimer: "Chart readings are for reference only; your destiny is in your own hands.",
    },
    card: {
      title: "Destiny Card", zodiac: "Zodiac", dayMaster: "Day Master",
      download: "Download", share: "Share",
      downloaded: "Card downloaded", exportError: "Export failed, please retry",
      shareText: "My BaZi summary · CiAO Merit",
      shareHint: "Card image downloaded — attach it in WhatsApp to share",
      placeholder: "Generating summary…",
    },
    bankin: {
      title: "Sign Up · Bank Transfer",
      step1: "Confirm",
      step2: "Transfer",
      step3: "Upload Receipt",
      step4: "Pending",
      usePoints: "Redeem merit points",
      pointsAvail: "Available points",
      cashToPay: "Amount to transfer",
      participant: "Participant Info",
      bankInfo: "Please transfer to the account below",
      bankName: "Bank",
      accountName: "Account Name",
      accountNo: "Account No.",
      uploadReceipt: "Upload transfer receipt",
      bankRef: "Bank reference (optional)",
      pendingTitle: "Signed up, pending confirmation",
      pendingDesc: "We received your sign-up and receipt. Points will be credited once admin confirms. Track it on your profile page.",
      createOrder: "Confirm & Proceed",
      submitReceipt: "Submit Receipt",
      profileNeeded: "Please log in before signing up",
    },
    orderStatus: {
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
    },
    profile: {
      title: "My Profile",
      info: "Personal Info",
      myProjects: "My Projects",
      referral: "Refer Friends",
      myPoints: "My Merit Points",
      referralDesc: "Share your referral link. Friends who register earn you 0.1 points, plus 5% points on their spending!",
      referralCode: "My referral code",
      referralLink: "Referral link",
      whoJoined: "Friends who joined via you",
      noReferral: "No friends have joined yet. Share your link!",
      noOrders: "You haven't joined any projects yet",
      ledger: "Points History",
      totalReward: "Total referral reward",
      uploadReceipt: "Upload Receipt", reupload: "Re-upload", viewReceipt: "View receipt",
      awaitingReceipt: "Awaiting payment proof",
      uploadReceiptDesc: "Upload a screenshot of your bank transfer receipt. Points are credited once an admin confirms it.",
      receiptImage: "Receipt image", bankRef: "Bank reference (optional)", receiptUploaded: "Receipt uploaded, awaiting admin confirmation",
    },
    lotus: {
      meaning: "Meaning of Folding Lotus",
      class: "Lotus Folding Class",
      paper: "Buy Lotus Paper",
      videos: "Teaching Videos",
      light: "Light a Lotus",
      blessing: "1st-Day Lotus Blessing",
    },
    deity: {
      intro: "Deities",
      map: "Deity Map",
      searchPlaceholder: "Search deity, e.g. Guanyin",
      mapNeedKey: "The map needs a Google Maps API Key (configure in Admin). Deity addresses below are clickable for navigation.",
      address: "Address",
    },
    admin: {
      title: "Admin Console",
      overview: "Overview",
      orders: "Orders / Remittance",
      projects: "Projects",
      members: "Members",
      deities: "Deities",
      settings: "Settings",
      members_count: "Total Members",
      pending: "Pending Orders",
      revenue: "Confirmed Revenue (RM)",
      pointsIssued: "Points Issued",
      approve: "Approve",
      reject: "Reject",
      viewReceipt: "View Receipt",
      export: "Export Excel",
      addProject: "Add Project",
      editProject: "Edit Project",
      addDeity: "Add Deity",
      revenueByCat: "Revenue by Category",
      dailyRevenue: "Daily Revenue",
      noReceipt: "No receipt uploaded",
    },
    footer: {
      about: "CiAO Merit is a platform that connects kindness and shares blessings.",
      contact: "Contact Us",
      quickLinks: "Quick Links",
      rights: "All rights reserved",
    },
    categories: {
      daily_merit: "Daily Merit",
      merit_project: "Merit Projects",
      charity: "Charity",
      lotus: "Lotus Blessing",
    },
  },
};

const EXTRA = {
  zh: {
    nav: { testimonials: "善信见证", services: "尊享服务", faq: "常见问题", shop: "功德店铺", profile: "个人后台" },
    categories: { service: "尊享服务", shop: "功德店铺" },
    shop: {
      title: "功德店铺", subtitle: "结缘开运好物，护佑平安 · 每件皆可累积功德点数",
      stock: "库存", soldOut: "已售罄", inStock: "现货", buy: "立即请购",
      shippingTitle: "收货资料", shippingName: "收件人", shippingPhone: "联系电话",
      shippingAddress: "收货地址", addressPlaceholder: "请填写完整收货地址（含邮区号）",
      empty: "店铺商品即将上架，敬请期待 🙏",
    },
    chartx: {
      recTitle: "功德推荐", recDesc: "依据你的五行强弱，宜多修以下功德以补益命局：",
      needLabel: "宜补五行",
      yearTitle: "流年详批", selectYear: "选择年份", viewDetail: "查看该年详批",
      liuyue: "流月", yearReading: "年度解读", yearAdvice: "开运建议", yearCaution: "温和提醒",
      loadingYear: "正在推算该年运势…", monthCol: "月", dayunYears: "该运流年",
      pickDayun: "点击某步大运，展开其十年流年",
    },
    emailx: {
      title: "运程邮件订阅",
      optInLabel: "接收运程邮件", optInDesc: "开启后，你将收到每日/每周运程邮件。",
      sendDaily: "发送今日运程到邮箱", sendWeekly: "发送本周运程到邮箱",
      sent: "邮件已发送 ✅", notConfigured: "邮件服务尚未配置，暂时无法发送。", sendFail: "发送失败，请稍后再试",
      notConfiguredHint: "邮件服务尚未配置。配置完成后即可收发运程邮件。",
    },
    faq: {
      title: "常见问题", subtitle: "关于功德、付款、点数与祈福的常见解答",
      empty: "暂无常见问题", loading: "加载中…", error: "加载失败，请稍后再试", retry: "重新加载",
      stillQuestions: "还有其他疑问？", contactUs: "欢迎透过 WhatsApp 联系我们",
    },
    faqx: {
      manage: "常见问题管理", add: "新增问题", edit: "编辑问题",
      questionZh: "问题 (中)", questionEn: "问题 (英)", answerZh: "答案 (中)", answerEn: "答案 (英)",
      sortOrder: "排序", active: "启用", deleteConfirm: "确定要删除这条常见问题吗？",
      emptyAdmin: "还没有常见问题，点击「新增问题」开始添加。",
    },
    dashboard: {
      career: "事业运势", health: "健康运势", love: "爱情人际", luck: "好运指数",
      servicesTitle: "会员尊享服务", servicesDesc: "命理 · 风水 · 专属咨询",
      selectDate: "选择日期", otherDay: "查看其他日期", fortuneOf: "运程",
      indexLabel: "指数",
      wealth: "财运", dos: "今日宜", luckyHours: "今日吉时", actionAdvice: "行动建议",
    },
    testimonials: {
      title: "善信见证", subtitle: "来自善信们的真挚分享",
      submitTitle: "分享我的见证", yourName: "你的名字", yourMessage: "你的见证内容",
      submitBtn: "提交见证",
      pendingNote: "提交后需经管理员审核通过，才会公开显示。",
      thanks: "感恩分享！你的见证已提交，待审核通过后即会公开。",
      myTitle: "我的见证记录", empty: "还没有善信见证，快来成为第一位分享的人！",
      loginToShare: "登入会员即可分享你的见证",
      statusPending: "待审核", statusApproved: "已公开", statusRejected: "未通过",
    },
    service: { deliverNote: "付款确认后由师父人工准备并交付", freeReg: "免费预约登记" },
    deityx: { locations: "地点 / 庙宇", backToList: "返回神明列表", viewDetail: "查看详情", navigate: "导航前往", intro: "神明简介" },
    adminx: {
      testimonials: "善信见证", lotusMgmt: "莲花管理", tagsMgmt: "标签管理", allCategories: "全部分类", faq: "常见问题",
      videos: "教学视频", addVideo: "新增视频", videoTitle: "视频标题(中)", videoTitleEn: "视频标题(英)", videoUrl: "视频链接 (embed url)",
      lotusMeaning: "折莲意义文案", locations: "地点管理", addLocation: "新增地点", locName: "地点名称", locAddress: "地址",
      statusPending: "待审核", statusApproved: "已公开", statusRejected: "未通过", pendingReview: "待审核见证",
      allocation: "收入分配（按月）", allocationDesc: "依已确认订单实收现金计算 · 5% 奖励池 / 15% 团队经费 / 10% 平台管理 / 70% 项目费用",
      month: "月份", monthTotal: "已确认收入", rewardPool: "奖励池 5%", teamFund: "团队经费 15%",
      platformMgmt: "平台管理 10%", projectCost: "项目费用 70%", allocationEmpty: "暂无已确认收入数据",
      system: "系统管理",
      adminAccounts: "管理员账号", adminAccountsDesc: "新增或移除可登录后台的管理员账号。",
      addAdmin: "新增管理员", adminAdded: "管理员已新增",
      dataMaintenance: "数据维护 · 清理测试数据",
      cleanupDesc: "正式启用前，一键清除测试/演示交易数据，保留管理员账号与目录内容。此操作无法撤销。",
      cleanupDelete: "将删除：所有订单、点数流水、推荐记录、善信见证、运势缓存，以及所有非管理员会员账号。",
      cleanupKeep: "将保留：管理员账号、功德项目、神明资料、常见问题、系统设置。",
      cleanupButton: "清理测试数据",
      cleanupConfirmTitle: "确认清理测试数据？",
      cleanupConfirmDesc: "此操作会永久删除所有订单、点数流水、推荐、见证与非管理员会员，且无法撤销。是否继续？",
      cleanupConfirmButton: "确认清理", cleanupDone: "测试数据已清理",
      uploadReceipt: "上传付款证明", replaceReceipt: "替换付款证明",
      uploadReceiptDesc: "会员来不及上传付款证明时，管理员可在此代为上传。上传后订单将进入「待确认」，请再点绿色勾确认入账。",
      receiptImage: "付款证明图片", bankRef: "汇款参考（可选）", receiptSaved: "付款证明已上传",
      emailTab: "邮件", emailMgmt: "邮件管理 (Gmail 群发)",
      emailConfigured: "已配置", emailNotConfigured: "未配置",
      emailSetupHint: "尚未配置发信邮箱。请提供一个 Gmail 邮箱与其「应用专用密码」（需先开启两步验证），填入后端 .env 的 GMAIL_SMTP_USER 与 GMAIL_SMTP_APP_PASSWORD 并重启后端，即可群发邮件（无需域名）。",
      emailTestTitle: "测试发信", emailTestDesc: "输入邮箱，发送一封测试邮件，验证配置是否正常。", emailTestBtn: "发送测试邮件",
      emailBroadcastTitle: "群发运程邮件", emailBroadcastDesc: "立即向所有已订阅、且资料完整的会员发送每日/每周运程邮件。",
      emailBroadcastDaily: "群发每日运程", emailBroadcastWeekly: "群发每周运程",
      emailSent: "成功", emailFailed: "失败", emailSkipped: "跳过",
      emailScheduleTitle: "自动发送时间", emailScheduleDesc: "设置每日/每周运程的自动发送时间（马来西亚时间 UTC+8）。",
      emailEnabled: "启用自动发送", emailDailyTime: "每日运程发送时间", emailWeeklyTime: "每周运程发送时间",
      weekday: "星期", emailNextRun: "下次自动发送", emailSaveSchedule: "保存时间设置", emailScheduleSaved: "发送时间已更新",
      emailLogTitle: "发送记录", emailLogDesc: "最近 50 条群发 / 测试发送记录。", emailLogEmpty: "暂无发送记录",
      emailLogTime: "时间", emailLogKind: "类型", emailLogTrigger: "触发", emailLogRecipients: "查看收件人",
      triggerManual: "手动", triggerScheduled: "自动", triggerAdminTest: "测试",
      kindDaily: "每日运程", kindWeekly: "每周运程", kindTest: "测试邮件",
      emailPreview: "预览", emailPreviewTitle: "邮件预览",
      emailUnsubTitle: "退订会员", emailUnsubDesc: "已取消订阅运程邮件的会员及退订时间。",
      emailUnsubEmpty: "暂无退订会员", emailUnsubWhen: "退订时间",
    },
  },
  en: {
    nav: { testimonials: "Testimonials", services: "Services", faq: "FAQ", shop: "Merit Shop", profile: "Profile" },
    categories: { service: "Premium Services", shop: "Merit Shop" },
    shop: {
      title: "Merit Shop", subtitle: "Auspicious items for blessing & protection · every purchase earns merit points",
      stock: "Stock", soldOut: "Sold out", inStock: "In stock", buy: "Buy Now",
      shippingTitle: "Shipping Details", shippingName: "Recipient", shippingPhone: "Phone",
      shippingAddress: "Shipping address", addressPlaceholder: "Full delivery address (incl. postcode)",
      empty: "Products coming soon 🙏",
    },
    chartx: {
      recTitle: "Merit Recommendations", recDesc: "Based on your five-element balance, these merit deeds are recommended to nourish your chart:",
      needLabel: "Boost element",
      yearTitle: "Yearly Detail", selectYear: "Select year", viewDetail: "View year detail",
      liuyue: "Monthly", yearReading: "Yearly Reading", yearAdvice: "Luck Tips", yearCaution: "Gentle Notes",
      loadingYear: "Calculating this year's fortune…", monthCol: "Mo.", dayunYears: "Years in cycle",
      pickDayun: "Click a luck cycle to expand its 10 annual years",
    },
    emailx: {
      title: "Fortune Email Subscription",
      optInLabel: "Receive fortune emails", optInDesc: "When on, you'll receive daily/weekly fortune emails.",
      sendDaily: "Email me today's fortune", sendWeekly: "Email me this week's fortune",
      sent: "Email sent \u2705", notConfigured: "Email service is not configured yet.", sendFail: "Send failed, please try again",
      notConfiguredHint: "Email service is not configured yet. Once set up, you can send/receive fortune emails.",
    },
    faq: {
      title: "Frequently Asked Questions", subtitle: "Common answers about merit, payment, points and blessings",
      empty: "No questions yet", loading: "Loading…", error: "Failed to load, please try again", retry: "Reload",
      stillQuestions: "Still have questions?", contactUs: "Feel free to reach us on WhatsApp",
    },
    faqx: {
      manage: "FAQ Management", add: "Add Question", edit: "Edit Question",
      questionZh: "Question (ZH)", questionEn: "Question (EN)", answerZh: "Answer (ZH)", answerEn: "Answer (EN)",
      sortOrder: "Sort", active: "Active", deleteConfirm: "Delete this FAQ?",
      emptyAdmin: "No FAQs yet. Click \"Add Question\" to create one.",
    },
    dashboard: {
      career: "Career", health: "Health", love: "Love & Social", luck: "Luck Index",
      servicesTitle: "Member Premium Services", servicesDesc: "Destiny · Feng Shui · Consultation",
      selectDate: "Select date", otherDay: "Other day", fortuneOf: "Fortune",
      indexLabel: "Index",
      wealth: "Wealth", dos: "Do Today", luckyHours: "Auspicious Hours", actionAdvice: "Action Advice",
    },
    testimonials: {
      title: "Testimonials", subtitle: "Heartfelt sharing from our community",
      submitTitle: "Share My Testimonial", yourName: "Your name", yourMessage: "Your testimonial",
      submitBtn: "Submit",
      pendingNote: "Your testimonial will be shown publicly after admin approval.",
      thanks: "Thank you! Your testimonial has been submitted and will appear after approval.",
      myTitle: "My Testimonials", empty: "No testimonials yet. Be the first to share!",
      loginToShare: "Log in as a member to share your testimonial",
      statusPending: "Pending", statusApproved: "Published", statusRejected: "Rejected",
    },
    service: { deliverNote: "Prepared and delivered by our master after payment is confirmed", freeReg: "Free registration" },
    deityx: { locations: "Locations / Temples", backToList: "Back to deities", viewDetail: "View detail", navigate: "Navigate", intro: "About" },
    adminx: {
      testimonials: "Testimonials", lotusMgmt: "Lotus", tagsMgmt: "Tags", allCategories: "All", faq: "FAQ",
      videos: "Teaching Videos", addVideo: "Add Video", videoTitle: "Title (ZH)", videoTitleEn: "Title (EN)", videoUrl: "Video embed URL",
      lotusMeaning: "Lotus meaning content", locations: "Locations", addLocation: "Add Location", locName: "Location name", locAddress: "Address",
      statusPending: "Pending", statusApproved: "Published", statusRejected: "Rejected", pendingReview: "Pending review",
      allocation: "Revenue Allocation (Monthly)", allocationDesc: "Based on actual cash of confirmed orders · 5% Reward Pool / 15% Team Fund / 10% Platform / 70% Project Cost",
      month: "Month", monthTotal: "Confirmed Revenue", rewardPool: "Reward Pool 5%", teamFund: "Team Fund 15%",
      platformMgmt: "Platform 10%", projectCost: "Project Cost 70%", allocationEmpty: "No confirmed revenue yet",
      system: "System",
      adminAccounts: "Admin Accounts", adminAccountsDesc: "Add or remove admin accounts that can access the admin panel.",
      addAdmin: "Add Admin", adminAdded: "Admin added",
      dataMaintenance: "Data Maintenance · Clear Test Data",
      cleanupDesc: "Before going live, clear all test/demo transactional data in one click. Admin accounts and catalog content are kept. This cannot be undone.",
      cleanupDelete: "Will delete: all orders, points ledger, referrals, testimonials, fortune cache, and all non-admin member accounts.",
      cleanupKeep: "Will keep: admin accounts, projects, deities, FAQ, and settings.",
      cleanupButton: "Clear Test Data",
      cleanupConfirmTitle: "Clear all test data?",
      cleanupConfirmDesc: "This permanently deletes all orders, points ledger, referrals, testimonials and non-admin members. This cannot be undone. Continue?",
      cleanupConfirmButton: "Yes, clear", cleanupDone: "Test data cleared",
      uploadReceipt: "Upload Receipt", replaceReceipt: "Replace receipt",
      uploadReceiptDesc: "If a member has not uploaded their payment proof, an admin can upload it here. The order becomes 'Pending' \u2014 click the green check to confirm and credit points.",
      receiptImage: "Receipt image", bankRef: "Bank reference (optional)", receiptSaved: "Receipt uploaded",
      emailTab: "Email", emailMgmt: "Email (Gmail broadcast)",
      emailConfigured: "Configured", emailNotConfigured: "Not configured",
      emailSetupHint: "Email sender not configured yet. Provide a Gmail address and its App Password (enable 2-Step Verification first), set GMAIL_SMTP_USER and GMAIL_SMTP_APP_PASSWORD in the backend .env and restart the backend to start sending (no domain required).",
      emailTestTitle: "Test send", emailTestDesc: "Enter an email to send a test message and verify the configuration.", emailTestBtn: "Send test email",
      emailBroadcastTitle: "Broadcast fortune emails", emailBroadcastDesc: "Send daily/weekly fortune emails now to all subscribed members with a complete profile.",
      emailBroadcastDaily: "Broadcast daily", emailBroadcastWeekly: "Broadcast weekly",
      emailSent: "Sent", emailFailed: "Failed", emailSkipped: "Skipped",
      emailScheduleTitle: "Auto-send schedule", emailScheduleDesc: "Set when daily/weekly fortune emails are sent automatically (Malaysia time, UTC+8).",
      emailEnabled: "Enable auto-send", emailDailyTime: "Daily send time", emailWeeklyTime: "Weekly send time",
      weekday: "Weekday", emailNextRun: "Next auto-send", emailSaveSchedule: "Save schedule", emailScheduleSaved: "Schedule updated",
      emailLogTitle: "Send log", emailLogDesc: "Last 50 broadcast / test sends.", emailLogEmpty: "No sends yet",
      emailLogTime: "Time", emailLogKind: "Type", emailLogTrigger: "Trigger", emailLogRecipients: "View recipients",
      triggerManual: "Manual", triggerScheduled: "Auto", triggerAdminTest: "Test",
      kindDaily: "Daily", kindWeekly: "Weekly", kindTest: "Test",
      emailPreview: "Preview", emailPreviewTitle: "Email Preview",
      emailUnsubTitle: "Unsubscribed Members", emailUnsubDesc: "Members who opted out of fortune emails, and when.",
      emailUnsubEmpty: "No unsubscribes yet", emailUnsubWhen: "Unsubscribed at",
    },
  },
};

function _deepMerge(a, b) {
  for (const k in b) {
    if (b[k] && typeof b[k] === "object" && !Array.isArray(b[k])) {
      a[k] = _deepMerge(a[k] || {}, b[k]);
    } else {
      a[k] = b[k];
    }
  }
  return a;
}
_deepMerge(translations.zh, EXTRA.zh);
_deepMerge(translations.en, EXTRA.en);

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ciao_lang") || "zh");

  useEffect(() => {
    localStorage.setItem("ciao_lang", lang);
    document.documentElement.lang = lang === "zh" ? "zh-CN" : "en";
  }, [lang]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = translations[lang];
      for (const p of parts) {
        if (cur == null) return path;
        cur = cur[p];
      }
      return cur == null ? path : cur;
    },
    [lang]
  );

  // choose bilingual inline
  const L = useCallback((zh, en) => (lang === "zh" ? zh : en || zh), [lang]);

  // pick a *_zh / *_en field from a backend object with fallback
  const pick = useCallback(
    (obj, base) => {
      if (!obj) return "";
      const val = obj[`${base}_${lang}`];
      if (val) return val;
      return obj[`${base}_zh`] || obj[`${base}_en`] || "";
    },
    [lang]
  );

  const toggle = useCallback(() => setLang((l) => (l === "zh" ? "en" : "zh")), []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, L, pick }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
}
